// Placeholder for future experiments to preserve import
const EXPERIMENTS = {

    /** EVR-3704 - Renewal Table Bonus (Clean-up task https://ratehub.atlassian.net/browse/EVR-3711) */
    // Adds experiment to the Renewal Table to show a bonus column - https://cms.ratehub.ca/experiments/mtg-renewal-table-bonus/
    mtgProductTableRenewalBonus: 'mtg-renewal-table-bonus',
    gocMortgageReform: 'goc-mortgage-reform',
};

export default EXPERIMENTS;
